import React from "react";
import SalesPagesListContainer from "../../modules/GASalesPages/containers/SalesPagesListContainer/SalesPagesListContainer";

const GASalesPagesList = () => {
  return <SalesPagesListContainer />;
};

export default GASalesPagesList;
